<template>
    <div class="page-wrapper">
        <!-- 地图 -->
        <div class="geoPage" v-if="mapShow">
            <div class="movie-box page-absolute back-wrapper">
                <MovieGoBack :style="backstyle" :titleStyle="arrowStyle" :arrowStyle="arrowStyle" :text="'位置信息'"></MovieGoBack>
            </div>
            <iframe
            width="100%"
            height="100%"
            frameborder="0"
            scrolling="no"
            :src="
            'https://apis.map.qq.com/uri/v1/geocoder?coord=' +
                latitude +
                ',' +
                longitude +
                '&referer=' +
                mapKey
            "
            >
            </iframe>
        </div>
    </div>
</template>

<script>
import { KEY } from "@libs/geolocation.js";
// import { isWeixin } from "@utils/index";
import MovieGoBack from "@components/MovieGoBack.vue";

export default {
    name: "TicketMap",
    components: {
        MovieGoBack
    },
    data: function () {
        return {
            backstyle: {
                background: "#fff"
            },
            arrowStyle: {
                color: "#666 !important"
            },
            mapKey: KEY,
            mapShow: false,
            longitude: this.$route.query.longitude,
            latitude: this.$route.query.latitude
        };
    },
    mounted: function () {
        this.selfLocation();
    },
    methods: {
        selfLocation: function () {
            // let _isWeixin = isWeixin();
            // if (_isWeixin) {
            //     let config = {
            //         latitude: parseFloat(this.latitude),
            //         longitude: parseFloat(this.longitude)
            //     };
            //     wechat().then((wx)=>{
            //         wx.openLocation(config)
            //     }).catch((err)=>{
            //         console.log(err);
            //         this.mapShow = true;
            //     });
            // } else {
                this.mapShow = true;
            // }
        }
    }
}
</script>

<style scoped>
.geoPage {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 300;
}
.back-wrapper {
    top: 0;
    left: 0;
    z-index: 350;
}
</style>